import React, { Component } from 'react'

class StudentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      school: '',
      endOfStudies: '',
      certificat: null,
      dragOver: false,
      submitted: false,
      loading: false,
      error: '',
    };
    this.fileRef = React.createRef();
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleFile = (file) => {
    if (file) {
      const valid = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!valid.includes(file.type)) {
        this.setState({ error: 'Format accepté : PDF, JPG ou PNG.' });
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.setState({ error: 'Fichier trop volumineux (10 Mo max).' });
        return;
      }
      this.setState({ certificat: file, error: '' });
    }
  }

  handleFileChange = (e) => {
    this.handleFile(e.target.files[0]);
  }

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ dragOver: false });
    if (e.dataTransfer.files.length) {
      this.handleFile(e.dataTransfer.files[0]);
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, email, school, endOfStudies, certificat } = this.state;
    if (!firstName || !lastName || !email || !school || !endOfStudies || !certificat) {
      this.setState({ error: 'Merci de remplir tous les champs.' });
      return;
    }

    this.setState({ loading: true, error: '' });

    const formData = new FormData();
    formData.append('first_name', firstName);
    formData.append('last_name', lastName);
    formData.append('email', email);
    formData.append('school_name', school);
    formData.append('end_of_studies', endOfStudies);
    formData.append('certificat', certificat);

    try {
      const res = await fetch('https://lama.fetchy.vet/api/user/student/register/', {
        method: 'POST',
        body: formData,
      });
      if (res.ok) {
        this.setState({ submitted: true });
      } else {
        const data = await res.json().catch(() => ({}));
        this.setState({ error: data.error || 'Une erreur est survenue. Réessaie plus tard.' });
      }
    } catch (err) {
      this.setState({ error: 'Une erreur est survenue. Réessaie plus tard.' });
    }
    this.setState({ loading: false });
  }

  render() {
    const { firstName, lastName, email, school, endOfStudies, certificat, dragOver, submitted, loading, error } = this.state;

    return (
      <div>
        <div className="tc" style={{ marginBottom: 24 }}>
          <span className="eyebrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
            Étudiants
          </span>
          <h2 style={{ marginTop: 8, fontSize: 'clamp(1.5rem, 1.2rem + 2vw, 2rem)' }}>Accès gratuit pour les étudiants.</h2>
          <p className="muted" style={{ margin: '0 auto', maxWidth: '48ch', fontSize: 15 }}>
            Sur justificatif de scolarité — on te répond sous 48h.
          </p>
        </div>

        {submitted ? (
          <div className="stu-success">
            <div className="stu-success__ic">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <h2>Demande envoyée !</h2>
            <p>Merci ! On revient vers toi sous 48h avec tes identifiants.</p>
          </div>
        ) : (
          <form className="stuform" onSubmit={this.handleSubmit}>
            <div className="sturow sturow--2">
              <div>
                <label className="field-lbl">Prénom</label>
                <input className="field" name="firstName" value={firstName} onChange={this.handleChange} placeholder="Prénom" required />
              </div>
              <div>
                <label className="field-lbl">Nom</label>
                <input className="field" name="lastName" value={lastName} onChange={this.handleChange} placeholder="Nom" required />
              </div>
            </div>

            <div>
              <label className="field-lbl">Email</label>
              <input className="field" type="email" name="email" value={email} onChange={this.handleChange} placeholder="toi@ecole.fr" required />
            </div>

            <div>
              <label className="field-lbl">École vétérinaire</label>
              <input className="field" name="school" value={school} onChange={this.handleChange} placeholder="Nom de ton école" required />
            </div>

            <div>
              <label className="field-lbl">Date de fin des études</label>
              <input className="field" type="date" name="endOfStudies" value={endOfStudies} onChange={this.handleChange} required />
            </div>

            <div>
              <label className="field-lbl">Certificat de scolarité</label>
              <div
                className={`stuupload${certificat ? ' has-file' : ''}${error && !certificat ? ' err' : ''}${dragOver ? ' hover' : ''}`}
                onClick={() => this.fileRef.current.click()}
                onDragOver={(e) => { e.preventDefault(); this.setState({ dragOver: true }); }}
                onDragLeave={() => this.setState({ dragOver: false })}
                onDrop={this.handleDrop}
              >
                <input
                  ref={this.fileRef}
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={this.handleFileChange}
                  style={{ display: 'none' }}
                />
                <div className="stuupload__label">
                  {certificat ? (
                    <>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                      {certificat.name}
                    </>
                  ) : (
                    <>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                      Glisse ton fichier ici ou clique pour choisir
                    </>
                  )}
                </div>
                {!certificat && <div className="stuupload__hint">PDF, JPG ou PNG — 10 Mo max</div>}
              </div>
            </div>

            {error && (
              <p style={{ color: 'var(--coral-600)', fontSize: 14, margin: 0 }}>{error}</p>
            )}

            <button
              type="submit"
              className="vt-btn vt-btn-call vt-btn-lg w100"
              disabled={loading}
            >
              {loading ? 'Envoi…' : 'Envoyer ma demande'}
            </button>
            <p className="stufoot-note">Ton certificat sera vérifié manuellement. On ne le partage jamais.</p>
          </form>
        )}
      </div>
    )
  }
}

export default StudentForm;
